import { useState } from "react";
import { api, apiError } from "@/lib/api";
import { useMeta } from "@/hooks/useMeta";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { toast } from "sonner";

/** Workflow status change (owner / manager scope). Full edits remain Super Admin only. */
export default function LeadStatusControl({ lead, onChanged }) {
  const meta = useMeta();
  const [busy, setBusy] = useState(false);
  const change = async (status) => {
    if (status === lead.status) return;
    setBusy(true);
    try {
      const { data } = await api.post(`/leads/${lead.id}/status`, { status });
      toast.success(`Status changed to ${status}`);
      onChanged?.(data);
    } catch (e) { toast.error(apiError(e)); } finally { setBusy(false); }
  };
  return (
    <Select value={lead.status} onValueChange={change} disabled={busy}>
      <SelectTrigger className="h-11 w-48" data-testid="lead-status-select"><SelectValue placeholder="Status" /></SelectTrigger>
      <SelectContent>{(meta.lead_statuses || []).map((s) => <SelectItem key={s} value={s} data-testid={`lead-status-option-${s}`}>{s}</SelectItem>)}</SelectContent>
    </Select>
  );
}
